import { atom } from 'jotai';
import { FindViewpointsToolState } from '@/types';
import { Number3 } from '@abyss/3d-viewer';
import { GetStructureLocationsForInspectionDataLoaderQuery } from '@/__generated__/graphql';

export const findViewpointsToolState = atom<FindViewpointsToolState>(FindViewpointsToolState.INACTIVE);

export const currentVoxelPoint = atom<Number3 | undefined>(undefined);

export const currentVoxel = atom<
  | {
      voxelKey: string;
      largeVoxelKey: string;
    }
  | undefined
>(undefined);

export const largeVoxelData = atom<
  | {
      largeVoxelKey: string;
      voxels: {
        [voxelKey: string]: string[];
      };
    }
  | undefined
>(undefined);

export type FoundViewpoints = GetStructureLocationsForInspectionDataLoaderQuery['allLocations'];

export const foundViewpoints = atom<FoundViewpoints>([]);

export const showPointMarker = atom<boolean>(true);
